import { gql, TypedDocumentNode } from '@apollo/client';
import { AccountDesignerPreferencesVertical } from '../useDesigners';

export type GetDesignerPreferencesQueryVariables = {
  userId: string;
  vertical: AccountDesignerPreferencesVertical;
};

export type GetDesignerPreferencesQuery = {
  getDesignerPreferences: {
    designerId: number;
    __typename: 'RestPreferencesPayload';
  }[];
};

export const GET_DESIGNER_PREFERENCES_QUERY: TypedDocumentNode<
  GetDesignerPreferencesQuery,
  GetDesignerPreferencesQueryVariables
> = gql`
  query GetDesignerPreferencesQuery($userId: String!, $vertical: String!) {
    getDesignerPreferences(userId: $userId, vertical: $vertical)
      @rest(
        type: "RestPreferencesPayload"
        endpoint: "preferences"
        path: "/v1/preferences?user_id={args.userId}&vertical={args.vertical}&inference_type=explicit"
      ) {
      designerId: designer_id
    }
  }
`;
